import {
  compose, getContext, withState, withContext, withHandlers, withStateHandlers,
} from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ClientNotes from './clientNotes';
import { uiActions } from '../../../../state/ui';
import preloaderWhileLoading from '../../../../utils/enchancers/preloaderWhileLoading';
import { PRELOADER_DIMENSION } from '../../../../constants/ui';
import { OFFSET } from '../../../../constants/crm';
import { clientsSelectors } from '../../../../state/clients';
import { withPermissionHandlers } from '../../../../utils/helpers/permissionHelpers';

const mapStateToProps = (state, { clientId }) => ({
  isPending: clientsSelectors.getClientActionPending(state)('getClientNotesRequest'),
  notes: clientsSelectors.getClientNotesSelector(state)(clientId),
});

const mapDispatchToProps = {
  setOpenModal: uiActions.openModal,
};

const onCreateNoteHandler = ({ setOpenModal }) => () => {
  setOpenModal('createNoteModal');
};

const onActionHandler = modalName => ({ setSelectedNoteId, setOpenModal }) => (noteId) => {
  setSelectedNoteId(noteId);
  setOpenModal(modalName);
};

const onChangeSortingStateHandler = () => val => ({
  sortBy: val,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('selectedNoteId', 'setSelectedNoteId', 0),
  getContext({
    setActiveTab: PropTypes.func,
  }),
  withState('offset', 'setOffset', OFFSET),
  withHandlers({
    onCreateNote: onCreateNoteHandler,
    onEditNote: onActionHandler('editNoteModal'),
    onDeleteNote: onActionHandler('deleteNoteModal'),
  }),
  withStateHandlers(() => ({ sortBy: { val: { id: 0 } } }), {
    onChangeSorting: onChangeSortingStateHandler,
  }),
  withContext({
    selectedNoteId: PropTypes.func.isRequired,
    onEditNote: PropTypes.func.isRequired,
    onDeleteNote: PropTypes.func.isRequired,
  }, ({ selectedNoteId, onEditNote, onDeleteNote }) => ({
    selectedNoteId,
    onEditNote,
    onDeleteNote,
  })),
  preloaderWhileLoading({
    dimension: PRELOADER_DIMENSION.SMALL,
    delay: 600,
    isLoading: props => props.isPending,
  }),
  withPermissionHandlers,
);
export default enhance(ClientNotes);
